import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

interface UseUserFriendlyScheduledForProps {
  scheduledFor: string;
}

const useUserFriendlyScheduledFor = ({ scheduledFor }: UseUserFriendlyScheduledForProps) => {
  const { t } = useTranslation(null, {
    keyPrefix: 'Modules:Mobile:Common:Hooks:useUserFriendlyScheduledFor',
  });

  return useMemo(() => {
    if (!scheduledFor) {
      return t('calendar.asap');
    }

    return moment(scheduledFor).calendar(null, {
      sameDay: `[${t('calendar.today')}] HH:mm`,
      nextDay: `[${t('calendar.tomorrow')}] HH:mm`,
      nextWeek: 'dddd, D MMMM HH:mm',
      lastDay: 'dddd, D MMMM HH:mm',
      lastWeek: 'dddd, D MMMM HH:mm',
      sameElse: 'dddd, D MMMM HH:mm',
    });
  }, [scheduledFor]);
};

export default useUserFriendlyScheduledFor;
